const GENDER_PARAM = 'filter.p.m.custom.attribute_gender';

// Keep any other active facets/sort order while changing Gender. Shopify treats
// repeated values for one filter as OR, so Trans covers ftm, mtf, and trans.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-sbd-gender-values]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  event.preventDefault();
  const url = new URL(window.location.href);
  url.pathname = '/collections/our-models';
  url.searchParams.delete(GENDER_PARAM);
  link.dataset.sbdGenderValues.split(',').filter(Boolean).forEach(value => {
    url.searchParams.append(GENDER_PARAM, value);
  });
  window.location.assign(url);
});
